import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { APIService } from 'api/module'
import { CloudConnection } from 'elements-sdk'

@Component({
  templateUrl: './createClickGalleryModal.component.pug',
})
export class CreateClickGalleryModalComponent {
  description = ''

  @Input() name: string
  @Input() connection: CloudConnection

  constructor (
    private modalInstance: NgbActiveModal,
    private api: APIService,
  ) { }

  create = async () => {
    const gallery = await this.api.click.createClickGallery({
      connectionId: this.connection.id.toString(),
      clickGalleryUpdate: {
        name: this.name,
        description: this.description,
      },
    })
    this.modalInstance.close(gallery)
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
